import { useContext } from 'react';

import { MarcasContext } from '../contexts/MarcasContext';
import { MarcasContextData } from '../types/context';

export const useMarcas = (): MarcasContextData => useContext(MarcasContext);
